import { postLoginUrl } from "@routing/paths"
import { getQueryParam } from "@utils/url"

export const getPostLoginUrl = () => {
  const redirectUrl = getQueryParam("redirectUrl")
  return redirectUrl ?? postLoginUrl()
}
